import http from "./core";

export default {
  async query(filter) {
    const result = await http.post(`api/portal/ScheduleEvents`, filter);
    return result.data;
  },
  async setCheckedIn(id, data) {
    const result = await http.patch(
      `api/portal/ScheduleEvents/SetCheckedIn/${id}`,
      data
    );
    return result.data;
  },
  async cancelAppointment(id, scheduleEventId) {
    const result = await http.patch(
      `api/portal/ScheduleEvents/CancelAppointment/${id}/${scheduleEventId}`
    );
    return result.data;
  },
  async isPatientOutstandingBalance(id) {
    const result = await http.get(
      `api/portal/ScheduleEvents/IsPatientOutstandingBalance/${id}`
    );
    return result.data;
  },
  async getEventsByEoc(eocId) {
    return await http.get(`api/portal/ScheduleEvents/GetEventsByEoc/${eocId}`);
  }
};
